import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import './index.css'
import App from './App'

const container = document.getElementById('root')!
const tree = (
  <StrictMode>
    <App />
  </StrictMode>
)

// Public route'lar build sonrası prerender ediliyor (scripts/prerender.mjs), yani
// bu container dolu gelebilir — o durumda hydrate et, boşsa normal mount yap.
if (container.hasChildNodes()) {
  hydrateRoot(container, tree)
} else {
  createRoot(container).render(tree)
}

// Helmet head etiketlerini kendi requestAnimationFrame callback'inde işliyor;
// prerender snapshot'ı almadan önce iki RAF + küçük bir tick bekliyoruz ki
// Helmet'in DOM mutasyonları flush olmuş olsun.
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    setTimeout(() => {
      ;(window as unknown as { __APP_READY__?: boolean }).__APP_READY__ = true
    }, 50)
  })
})
